<template>
  <section class="pt-10" id="destination">
    <div id="overlay" class="overlay" v-if="loading">
      <div id="loader" class="loader">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="chat-container">
        <div class="requests-container">
          <label>My Requests</label>
          <ul class="requests-list custom-scroll">
            <li v-for="request in requests" :key="request.id" @click="selectRequest(request)" class="request-item">
              <div class="card mb-1 shadow-sm request-bubble" style="padding: 0px;">
                <div class="card-body mt-3">
                  <!-- 'New' or 'Opened' label -->
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <span v-if="request.reqStatus === '2'" class="request-label new-label badge bg-success">New</span>
                    
                    <span v-if="request.reqStatus === '3'" class="request-label closed-label badge bg-warning">Organizer
                      Fixed</span>
                  </div>
                  <div v-if="request.tourDetail">
                    <template v-if="isValidJSON(request.tourDetail)">
                      <p class="mb-1" style="font-size: 14px;"><strong>Check-in Date:</strong> {{ getTourDetail(request.tourDetail).check_in_date
                        }}</p>
                      <p  style="font-size: 14px;"><strong>Check-out Date:</strong> {{
                        getTourDetail(request.tourDetail).check_out_date }}</p>
                    </template>
                    <template v-else>
                      <p class="text-danger">Error: Invalid tour detail format.</p>
                    </template>
                  </div>
                </div>
              </div>
            </li>

          </ul>
        </div>

        <div class="chat-display custom-scroll">

          <div v-if="currentRequest">
            <div class="card shadow-sm border-0 mb-4">
              <div class="card-header bg-primary text-white">
                <h5 class="mb-0">Summary of Tour Request Details:</h5>
              </div>
              <div class="card-body">
                <div class="row g-3">
                  <div class="col-md-3" v-for="(detail, index) in tourDetails" :key="index">
                    <div class="card shadow-sm border-0 h-100">
                      <div class="card-body d-flex flex-column justify-content-center align-items-center">
                        <h6 class="card-title text-muted text-center" style="font-size: 12px;">{{ detail.label }}</h6>
                        <p class="card-text fw-bold">{{ detail.value }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card shadow-sm border-0 mb-3 mt-3">
                  <div class="card-body">
                    <h6 class="card-title text-muted mb-3"><strong>Activities</strong></h6>
                    <ul class="list-unstyled row ps-3">
                      <li v-for="activity in formatTourDetail(currentRequest.tourDetail).activities" :key="activity"
                        class="col-md-4 d-flex align-items-center mb-2">
                        <i class="bi bi-check-circle text-primary me-2"></i>
                        <span>{{ activity }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="row">
                  <!-- Special Activities Card -->
                  <div class="col-md-12 mb-3">
                    <div class="card shadow-sm border-0 h-100">
                      <div class="card-body text-start">
                        <h6 class="card-title text-muted"><strong>Special Activities</strong></h6>
                        <span class="text-primary d-block mt-2">{{
                          formatTourDetail(currentRequest.tourDetail).special_activities || 'N/A' }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Special Requirements Card -->
                  <div class="col-md-12 mb-3">
                    <div class="card shadow-sm border-0 h-100">
                      <div class="card-body text-start">
                        <h6 class="card-title text-muted"><strong>Special Requirements</strong></h6>
                        <span class="text-primary d-block mt-2">{{
                          formatTourDetail(currentRequest.tourDetail).special_requirements || 'N/A' }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card shadow-sm border-0 mb-4">
              <div class="card-header bg-info text-white">
                <h5 class="mb-0 text-white">Check replies</h5>
              </div>
              <div class="card-body">
                <div v-if="formatGuideReply(currentRequest.guideReply).length > 0">
                  <div v-for="(reply, index) in formatGuideReply(currentRequest.guideReply)" :key="index"
                    class="card mb-3">
                    <transition name="fade">
                      <div class="card shadow border-0 mb-3" @click="toggleReplyDetails(index)">
                        <div class="card-body">
                          <div class="d-flex justify-content-between align-items-start">
                            <div>
                              <h5 class="card-title text-primary mb-2">Reply {{ index + 1 }}</h5>
                              <h6 class="card-title text-muted mb-3">
                                <strong>{{ getOrgDetailById(reply.orgId)?.bName }}</strong>
                              </h6>
                              <span v-if="reply.status == '1'" class="request-label new-label badge bg-success">Selected Quation</span>
                              <p class="card-text mb-2" style="font-size: 1.1rem;">{{ truncatedReply(reply.reply, 30) }}
                              </p>

                              <!-- Conditional rendering for Show More button -->
                              <button v-if="replyDetailsIndex !== index"
                                class="btn btn-link text-decoration-none text-secondary">Show More...</button>
                            </div>

                            
                          </div>
                          <!-- Reply Details Section with Transition -->
                          <transition name="fade">
                            <div v-if="replyDetailsIndex === index" class="mt-1" id="replyDetails">
                              <div class="reply-body mb-4">
                                <div class="col-12">
                                  <h5 class="card-title text-primary mb-3">More Details...</h5>
                                  <div class="row mb-3">
                                    <div class="col-md-6">
                                      <p class="mb-1"><strong>Organization Name:</strong></p>
                                      <p>{{ getOrgDetailById(reply.orgId)?.bName }}</p>
                                    </div>
                                    <div class="col-md-6">
                                      <p class="mb-1"><strong>Owner Name:</strong></p>
                                      <p>{{ getOrgDetailById(reply.orgId)?.fName }} {{
                                        getOrgDetailById(reply.orgId)?.lName }}</p>
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-md-6">
                                      <p class="mb-1"><strong>Email:</strong></p>
                                      <p>{{ getOrgDetailById(reply.orgId)?.email }}</p>
                                    </div>
                                    <div class="col-md-6">
                                      <p class="mb-1"><strong>Contact:</strong></p>
                                      <p>{{ getOrgDetailById(reply.orgId)?.bCno }}</p>
                                    </div>
                                  </div>
                                  <div class="mb-3">
                                    <p class="mb-1"><strong>Address:</strong></p>
                                    <p>{{ getOrgDetailById(reply.orgId)?.bAddress }}</p>
                                  </div>
                                  <hr>
                                  <h6 class="mt-3">Full View of Reply:</h6>
                                  <p class="bg-light p-2 border rounded">{{ reply.reply }}</p>
                                </div>

                                <div class="reply-footer mb-3" style="padding-right: 20px;"  v-if="currentRequest.reqStatus !== '3'">
                                  <button type="button" class="btn btn-primary"
                                    @click="accept(getOrgDetailById(reply.orgId)?.id, currentRequest)">Accept</button>
                                  <!-- <button type="button" class="btn btn-secondary"
                                    @click="denied(selectedOrgDetail)">Denied</button> -->
                                  <button type="button" class="btn btn-danger" @click="closeReply">Close</button>
                                </div>
                              </div>
                            </div>
                          </transition>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
                <p v-else>No replies yet.</p>
              </div>

            </div>


          </div>
          <p v-else>No request selected.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery';
import Swal from 'sweetalert2';
import { Modal } from 'bootstrap';


export default {
  name: 'OrgRequestList',
  data() {
    return {
      requests: [],
      currentRequest: null,
      loading: false,
      selectedReply: null, // To store the reply details for popup
      replyDetailsIndex: null, // To track which reply's details are shown
      // other data properties
    };
  },
  mounted() {
    this.fetchRequests();

  },
  computed: {
    tourDetails() {
      const tourDetail = this.formatTourDetail(this.currentRequest.tourDetail);
      return [
        { label: 'Check-In Date', value: tourDetail.check_in_date },
        { label: 'Check-Out Date', value: tourDetail.check_out_date },
        { label: 'Adults', value: tourDetail.adults },
        { label: 'Children', value: tourDetail.children },

      ];
    },

  },

  methods: {
    // Check if a string is valid JSON
    isValidJSON(string) {
      try {
        JSON.parse(string);
        return true;
      } catch (e) {
        return false;
      }
    },

    // Parse and return the tour detail object
    getTourDetail(tourDetailString) {
      return JSON.parse(tourDetailString);
    },
    truncatedReply(text, wordLimit) {
      const words = text.split(" ");
      return words.length > wordLimit
        ? words.slice(0, wordLimit).join(" ") + "..."
        : text;
    },
    toggleReplyDetails(index) {
      this.replyDetailsIndex = this.replyDetailsIndex === index ? null : index; // Toggle the visibility
    },
    closeReply() {
      this.replyDetailsIndex = null; // Hide details when closing
    },
    fetchRequests() {
      const user = JSON.parse(localStorage.getItem('user'));
      const cusId = user?.id;

      if (!cusId) {
        console.error('Customer ID not found in local storage');
        return;
      }

      this.loading = true;
      $('#overlay').show(); // Show the loader overlay

      $.ajax({
        url: process.env.VUE_APP_API_URL +`/getRequestsCus/${cusId}`,
        method: 'GET',
        success: (data) => {
          const parsedData = data; // If the data comes as a string, parse it
          const fetchedRequests = parsedData[0].request || [];

          // Here we assign all orgDetail
          this.selectedOrgDetail = parsedData.map(item => item.orgDetail).flat() || [];

          // Filter out duplicate requests based on the request ID
          const uniqueRequests = this.getUniqueRequests(fetchedRequests);
          this.requests = uniqueRequests;
        },
        error: (error) => {
          console.error('Error fetching organization requests:', error);
          Swal.fire('Error', 'Failed to fetch requests. Please try again later.', 'error');
        },
        complete: () => {
          this.loading = false;
          $('#overlay').hide(); // Hide the loader overlay
        }
      });
    },

    getOrgDetailById(orgId) {
      if (!this.selectedOrgDetail || !Array.isArray(this.selectedOrgDetail)) {
        return null; // Return null if there's no organization detail
      }
      // Find the organization detail that matches the provided orgId
      return this.selectedOrgDetail.find(org => org.id === orgId) || null;
    },

    getUniqueRequests(requests) {
      const uniqueIds = new Set();
      return requests.filter((request) => {
        if (!uniqueIds.has(request.id)) {
          uniqueIds.add(request.id);
          return true; // Include the unique request
        }
        return false; // Exclude duplicate request
      });
    }
    ,
    accept(id, currentRequest) {
      const orgId = id;
      const reqId = currentRequest.id;
      console.log(orgId);
      console.log(reqId);

      this.loading = true;
      $('#overlay').show(); // Show the loader overlay

      $.ajax({
        url: process.env.VUE_APP_API_URL +`/acceptRequest`,
        method: 'post',
        contentType: 'application/json', // Ensuring JSON format
        data: JSON.stringify({ orgId: orgId, reqId: reqId }), // Send data as JSON string
        success: (response) => {
          // Log the response for debugging
          console.log("Server response:", response);
         
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Make your trip with you favorite Orgaizer.',
          }).then((result) => {
            if (result.isConfirmed) {
              // Code to execute after clicking "OK"
              // For example, redirecting to another page
              // window.location.href = '/'; // Replace with your desired URL
              location.reload();
            }
          });
        },
        error: (error) => {
          console.error('Error fetching organization requests:', error);
          Swal.fire('Error', 'Failed to fetch requests. Please try again later.', 'error');
        },
        complete: () => {
          this.loading = false;
          $('#overlay').hide(); // Hide the loader overlay
        }
      });
    },

    showReplyPopup(reply) {
      this.selectedReply = reply;
      const modalElement = document.getElementById('replyModal');
      const modalInstance = new Modal(modalElement); // Create a new modal instance
      modalInstance.show(); // Show the modal
    },
    selectRequest(request) {
      this.currentRequest = request;
    },

    formatTourDetail(tourDetail) {
      try {
        const details = JSON.parse(tourDetail);
        return {
          adults: details.adults,
          children: details.children,
          check_in_date: details.check_in_date,
          check_out_date: details.check_out_date,
          activities: details.activities.length ? details.activities : ['None'],
          special_activities: details.special_activities || 'None',
          special_requirements: details.special_requirements || 'None'
        };
      } catch (e) {
        return {
          adults: 'N/A',
          children: 'N/A',
          check_in_date: 'N/A',
          check_out_date: 'N/A',
          activities: ['N/A'],
          special_activities: 'N/A',
          special_requirements: 'N/A'
        };
      }
    },

    formatGuideReply(guideReply) {
      try {
        const replies = JSON.parse(guideReply);
        return replies.length ? replies : []; // Return replies as an array
      } catch (e) {
        return [];
      }
    }
  }
};
</script>


<style scoped>
.overlay {
  position: fixed;
  /* Fixed position */
  top: 0;
  /* Cover the top */
  left: 0;
  /* Cover the left */
  right: 0;
  /* Cover the right */
  bottom: 0;
  /* Cover the bottom */
  background: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  z-index: 1000;
  /* Ensure it appears above other content */
  display: flex;
  /* Use flex to center the loader */
  justify-content: center;
  /* Center horizontally */
  align-items: center;
  /* Center vertically */
}

.loader {
  position: fixed;
  /* Fixed position */
  left: 50%;
  /* Center horizontally */
  top: 50%;
  /* Center vertically */
  transform: translate(-50%, -50%);
  /* Translate to center */
  z-index: 1000;
  /* Ensure it appears above other content */
}

.custom-scroll {
  max-height: 500px;
  /* Set the height you want */
  overflow-y: auto;
  /* Enable vertical scrolling */
  padding: 15px;
  /* Optional: Add some padding */

}

/* Optional: Style for the scrollbar */
.custom-scroll::-webkit-scrollbar {
  width: 10px;
  /* Width of the scrollbar */
}

.custom-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* Background of the scrollbar track */
}

.custom-scroll::-webkit-scrollbar-thumb {
  background: #888;
  /* Color of the scrollbar thumb */
  border-radius: 5px;
  /* Rounded corners for the thumb */
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
  /* Color of the thumb on hover */
}

.fs-xl-2 {
  font-size: 2rem;
}

.chat-container {
  display: flex;
  /* Flexbox layout for side-by-side */
}

.requests-container {
  flex: 0 0 30%;
  /* Fixed size for requests */
  max-height: 500px;
  /* Limit height for scrolling */
  overflow-y: auto;
  /* Enable scrolling for overflow */
  padding-right: 10px;
  /* Spacing between requests and chat */
  border-right: 1px solid #ddd;
  /* Divider line */
}

.requests-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.request-item {
  position: relative;
  /* To position the labels */
  margin-bottom: 20px;
  /* Space between requests */
  cursor: pointer;
  /* Make the item clickable */
}

.request-label {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 0.8rem;
  color: white;
}

.new-label {
  background-color: #28a745;
  /* Green for new requests */
}

.opened-label {
  background-color: #528bed;
  /* Yellow for opened requests */
}

.reply-label {
  background-color: #cc4aed;
  /* Yellow for opened requests */
}

.closed-label {
  background-color: #ed4a4a;
  /* Yellow for opened requests */
}

.request-bubble {
  background-color: #c6e2f8;
  /* Light green for requests */
  border-radius: 20px;
  padding: 15px;
  max-width: 100%;
  /* Full width of the container */
  word-wrap: break-word;
  /* Wrap long words */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.request-bubble:hover {
  transform: scale(1.02);
  /* Slightly enlarge on hover */
}

.request-title {
  font-size: 1.2rem;
  /* Larger font for the title */
  margin: 0 0 10px;
  /* Space below the title */
  color: #333;
  /* Dark color for title */
}

.request-description {
  font-size: 1rem;
  /* Standard font size for the description */
  margin: 0 0 10px;
  /* Space below the description */
  color: #555;
  /* Gray color for description */
}

.chat-display {
  flex: 1;
  /* Take remaining space */
  padding-left: 10px;
  /* Spacing on the left */
}

.nested-list {
  list-style-type: disc;
  /* Bullet points for nested lists */
  margin-left: 20px;
  /* Indentation for nested lists */
  color: #333;
  /* Darker color for better readability */
}

.nested-list li {
  margin-bottom: 5px;
  /* Space between items */
  padding: 5px;
  /* Padding for clickable area */
  transition: background-color 0.2s;
  /* Smooth transition effect */
}

.nested-list li:hover {
  background-color: #e0f7fa;
  /* Light blue on hover */
  border-radius: 5px;
  /* Rounded corners on hover */
}

.message-bubble {
  background-color: #ffffff;
  /* Light gray for messages */
  border-radius: 20px;
  padding: 15px;
  max-width: 90%;
  /* Limit width of messages */
  word-wrap: break-word;
  /* Wrap long words */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  /* Add shadow for attractiveness */
}

.tour-detail {
  margin-top: 10px;
  /* Space above tour details */
}

.tour-detail-list {
  list-style-type: none;
  /* Remove default list styling */
  padding: 0;
  /* Remove padding */
  margin: 0;
  /* Remove margin */
}

.tour-detail-list li {
  margin-bottom: 5px;
  /* Space between list items */
}

.message-detail {
  margin: 0;
  /* Remove default margin */
}

.no-message {
  text-align: center;
  color: #888;
  /* Grey color for no message */
  flex: 1;
  /* Center in the display */
  display: flex;
  justify-content: center;
  align-items: center;
}

h3 {
  margin: 10px 0;
  /* Spacing above and below section headings */
}

.reply-container {
  padding: 15px 20px;
  /* Add padding */
  border: 1px solid #e0e0e0;
  /* Light border for definition */
  border-radius: 5px;
  /* Rounded corners */
  background-color: #ffffff;
  /* Light background */
  margin-top: 10px;
  /* Space above */
}

.reply-header {
  border-bottom: 2px solid #007bff;
  /* Blue line under header */
  padding-bottom: 10px;
  /* Space below header */
}

.reply-body {
  margin: 10px 0;
  /* Space above and below the body */
}

.reply-footer {
  display: flex;
  justify-content: flex-end;
  /* Align buttons to the left */
  gap: 10px;
  /* Space between buttons */
}

/* Optional: Button styles */
.btn {
  min-width: 80px;
  /* Uniform button width */
}

/* Transition styles */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
  {
  opacity: 0;
}
</style>
